







































































































































import LandCard, { InfoOption } from "./LandCard.vue";
import {
  defineComponent,
  ref,
  PropType,
  computed,
  onMounted,
  watch,
  nextTick,
  onBeforeUnmount,
  onActivated,
} from "@vue/composition-api";
import IconTextButton from "@/components/IconTextButton.vue";
import { ItemOption } from "@/components/NavItems.vue";
import { DRAW_MODEL } from "@/constants/drawModel";
import { eventHub } from "@/utils/eventHub";

import router from "@/router";

export type TabItem = {
  infoList: InfoOption[];
  isInit: boolean;
  refreshing: boolean;
  finished: boolean;
  err: boolean;
  loading: boolean;
  page: number;
  pageSize: number;
  // 列表没有数据时提示的文案
  emptyTip?: string;
  // 列表没有数据时是否显示 "绘制" 按钮
  emptyToDraw?: boolean;
  // 自定义滚动时选中逻辑
  customSelectionLogic?: boolean;
};

type NavItem = ItemOption & {
  legendTitle?: string;
  legendClass: string;
};

/**
 * 列表和地图交互业务组件
 */
export default defineComponent({
  props: {
    detailInfo: {
      type: Object as PropType<InfoOption>,
    },
    navList: {
      type: Array as PropType<NavItem[]>,
      required: true,
    },
    tabList: {
      type: Array as PropType<TabItem[]>,
      required: true,
    },
    drawModel: {
      type: String as () => DRAW_MODEL,
    },
    // 隐藏说明按钮
    hideExplanation: {
      type: Boolean,
      default: false,
    },
    // 没有详情模块
    noDetail: {
      type: Boolean,
      default: false,
    },
    // 进入后列表直接全屏
    initToFullScreen: {
      type: Boolean,
      default: false,
    },
    // 降低列表的高度
    mini: {
      type: Boolean,
      default: false,
    },
    // 反向选择选中地块
    // 点击地块后滚动滚动条到对应的位置
    invertSelectionLand: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["load"],
  components: {
    LandCard,
    IconTextButton,
  },
  setup(props, { emit }) {
    const refreshing = ref(false);
    const navActive = ref(0);
    const isShowList = ref(false);
    const isFullScreen = ref(false);

    onMounted(() => {
      // 点击地图上的地块时收起列表
      eventHub.$on("map-polygon-click", () => {
        handleHideList();
      });

      if (props.initToFullScreen) {
        isFullScreen.value = true;
        handleShowList();
      }

      // 没有详情直接显示列表
      if (props.noDetail) {
        handleShowList();
      }
    });

    // 切换列表
    const handleActiveChange = (index: number) => {
      navActive.value = index;
    };

    // ----------  列表显示隐藏，全屏相关逻辑  ----------

    const handleHideList = () => {
      if (!props.noDetail) {
        isShowList.value = false;
      }
    };

    const handleShowList = () => {
      isShowList.value = true;

      // 展开抽屉时，如果当前选中的列表未初始化则初始化
      if (!props.tabList[navActive.value].isInit) {
        emit("load", navActive.value);
        // 已初始化的列表根据当前滚动条所在位置选中对应的地块
      }
    };

    let container = document.getElementById("diduoduo_base_map_container");

    onMounted(() => {
      container = document.getElementById("diduoduo_base_map_container");
    });

    const handleBaseDrawerAfterEnter = () => {
      changeActiveByScroll();

      // 展开列表时根据地图内容区
      // 调整高度
      if (container) {
        let mapContainerHeight = "60%";
        const baseDrawerEl = document.querySelector(
          ".base-drawer"
        ) as HTMLDivElement;

        if (baseDrawerEl) {
          mapContainerHeight = baseDrawerEl.offsetTop - 34 + "px";
        }

        container.style.height = mapContainerHeight;
        eventHub.$emit("map-invalidate-size");
      }
    };

    const handleBaseDrawerBeforeLeave = () => {
      if (container) {
        container.style.height = "100%";
        eventHub.$emit("map-invalidate-size");
      }
    };

    onBeforeUnmount(() => {
      handleBaseDrawerBeforeLeave();
    });

    const handleDrawerUp = () => {
      isFullScreen.value = true;
    };

    const handleDrawerDown = () => {
      if (isFullScreen.value) {
        isFullScreen.value = false;
      } else {
        handleHideList();
      }
    };

    // ----------  触发加载相关逻辑  ----------

    // 滑到底部触发加载
    const handleStart = (index: number) => {
      emit("load", index);
    };

    // 列表切换，未初始化的触发加载
    watch(navActive, (current) => {
      if (!props.tabList[current].isInit) {
        emit("load", current);
      }
    });

    // 下拉刷新列表
    const handleRefresh = (tabIndex: number) => {
      const tabList = props.tabList;

      tabList[tabIndex].refreshing = false;
      tabList[tabIndex].finished = false;
      tabList[tabIndex].page = 1;
      tabList[tabIndex].loading = true;

      emit("load", tabIndex, true);
    };

    // ----------  根据滚动条位置选中地块逻辑  ----------

    const drawBodyRef = ref<HTMLDivElement[]>([]);
    const cardOffset: number[] = [];
    const currentActiveId: number[] = [];
    let eventFromInner = false;

    const scrollIsReady = () => {
      const activeNavIndex = navActive.value;

      const isOk =
        // 容器已存在
        drawBodyRef.value.length &&
        drawBodyRef.value[activeNavIndex] &&
        // 数据列表有数据
        props.tabList[activeNavIndex].isInit &&
        props.tabList[activeNavIndex].infoList.length &&
        // 非全屏状态
        !isFullScreen.value;

      // 如果当前列表单个项目的高度未计算或者为0，则计算其高度
      if (
        isOk &&
        (cardOffset[activeNavIndex] === undefined ||
          cardOffset[activeNavIndex] === 0)
      ) {
        const bodyContainer = drawBodyRef.value[activeNavIndex];
        const listEl = bodyContainer.getElementsByClassName("land-card");
        if (listEl.length && listEl[0]) {
          const firstElement = listEl[0] as HTMLDivElement;
          cardOffset[activeNavIndex] = parseFloat(
            getComputedStyle(firstElement).height
          );
          cardOffset[activeNavIndex] += parseFloat(
            getComputedStyle(firstElement).marginBottom
          );
        }
      }

      return (
        isOk &&
        cardOffset[activeNavIndex] !== 0 &&
        cardOffset[activeNavIndex] !== undefined
      );
    };

    // 根据滚动条位置选中某个 id
    const changeActiveByScroll = () => {
      if (scrollIsReady()) {
        const activeNavIndex = navActive.value;
        const bodyContainer = drawBodyRef.value[activeNavIndex];
        const localIndex = parseInt(
          (bodyContainer.scrollTop / cardOffset[activeNavIndex]).toFixed(0),
          10
        );

        const id = props.tabList[activeNavIndex].infoList[localIndex].id;
        currentActiveId[activeNavIndex] = id;

        if (props.tabList[activeNavIndex].customSelectionLogic) {
          emit("active-item-change", id);
        } else {
          // 因为该组件内页监听了这个事件，但是组件内的监听无需处理
          // 这里做一个特殊的标记
          eventFromInner = true;
          eventHub.$emit("set-active-graphic", id);
        }

        if (process.env.NODE_ENV === "development") {
          console.log(
            `√根据滚动条选中 id：单个地块高度：${cardOffset[activeNavIndex]}，当前选中的地块序号：${localIndex}`
          );
        }
      }
    };

    // 根据某个 id 滚动滚动条
    const changeScrollPositionByActive = (id: number) => {
      if (scrollIsReady()) {
        const activeNavIndex = navActive.value;
        const bodyContainer = drawBodyRef.value[activeNavIndex];

        const localIndex = props.tabList[activeNavIndex].infoList.findIndex(
          (item) => item.id === id
        );

        if (localIndex !== -1) {
          currentActiveId[activeNavIndex] = id;

          const scrollTop = localIndex * cardOffset[activeNavIndex];

          if (bodyContainer.scrollTop !== scrollTop) {
            bodyContainer.scrollTop = scrollTop;

            if (process.env.NODE_ENV === "development") {
              console.log(
                `×根据 id 滚动滚动条：当前选中的地块序号：${localIndex}`
              );
            }
          }
        }
      }
    };

    // 监听列表滚动
    let scrollTimer: number | null = null;
    const handleListScroll = () => {
      if (scrollTimer) {
        clearTimeout(scrollTimer);
      }
      scrollTimer = setTimeout(() => {
        changeActiveByScroll();
      }, 150);
    };

    // 监听全屏/非全屏状态变化
    watch(isFullScreen, (current, prev) => {
      if (prev && !current) {
        changeActiveByScroll();
      }
    });

    // 监听列表切换
    watch(navActive, (current) => {
      if (props.tabList[current].isInit) {
        nextTick(() => {
          changeActiveByScroll();
        });
      }
    });

    // 其它地方改变了选中地块
    // 如果配置了反向选中，则滚动滚动条到对应位置
    eventHub.$on("set-active-graphic", (id: number) => {
      if (!Array.isArray(id) && props.invertSelectionLand && !eventFromInner) {
        changeScrollPositionByActive(id);
      }
      eventFromInner = false;
    });

    // 跳转回来时如果对应的列表有选中的 id , 则滚动滚动条到对应位置
    onActivated(() => {
      if (currentActiveId[navActive.value] !== undefined) {
        changeScrollPositionByActive(currentActiveId[navActive.value]);
      }
    });

    // ----------  其它逻辑  ----------

    const handleToExplanation = () => {
      emit("to-explanation");
    };

    const handleToLandDetail = (info: InfoOption) => {
      emit("to-detail", info, navActive.value);
    };

    // 跳转到绘制页面
    const handleToDraw = () => {
      router.push({
        path: "/drawInner/draw",
        query: {
          no_back_app: "1",
        },
      });
    };

    return {
      handleToDraw,
      handleBaseDrawerAfterEnter,
      handleBaseDrawerBeforeLeave,
      drawBodyRef,
      handleListScroll,
      handleDrawerUp,
      handleDrawerDown,
      isFullScreen,
      refreshing,
      handleToLandDetail,
      handleToExplanation,
      handleActiveChange,
      handleStart,
      handleShowList,
      handleRefresh,
      navActive,
      isShowList,
      isShowControl: computed(() => {
        return (
          props.drawModel === DRAW_MODEL.readToCreate ||
          props.drawModel === DRAW_MODEL.read
        );
      }),
    };
  },
});
